import type { CSSProperties } from 'react';

type PropsType = {
  overrideStyle?: CSSProperties;
};

const HomeIcon = ({ overrideStyle = {} }: PropsType) => (
  <svg viewBox="0 0 16 16" fill="none" style={overrideStyle}>
    <path
      d="M14 11.3333V6.489C14 6.18041 13.8575 5.88911 13.6139 5.69965L8.61394 1.81076C8.25283 1.5299 7.74717 1.5299 7.38606 1.81076L2.38606 5.69965C2.14247 5.88911 2 6.18041 2 6.489V13.3333C2 13.6869 2.14048 14.026 2.39052 14.2761C2.64057 14.5261 2.97971 14.6666 3.33333 14.6666H6"
      stroke="#152934"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="10.6668" cy="10.0001" r="1.33333" stroke="#152934" />
    <path
      d="M13.3333 14.6667V14.0001C13.3333 13.2637 12.7364 12.6667 12 12.6667H9.33333C8.59695 12.6667 8 13.2637 8 14.0001V14.6667"
      stroke="#152934"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HomeIcon;
